import ReactComponent from './chatIcon.svg?react'

ReactComponent.displayName = 'ChatIcon'
export default ReactComponent
